import { render } from "./register.html?vue&type=template&id=2fa08d54&external"
import script from "./register.js?vue&type=script&lang=js&external"
export * from "./register.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__